import { Plus, Minus, Navigation, Loader2, Sun, Moon, LayoutGrid, Bell, BellOff, Sunrise } from "lucide-react";

const Btn = ({ testid, title, onClick, active, activeClass = "bg-primary text-primary-foreground", children }) => (
  <button
    data-testid={testid}
    title={title}
    onClick={onClick}
    className={`windy-ctl ${active ? activeClass : ""}`}
  >
    {children}
  </button>
);

export const ControlStack = ({
  mapRef,
  units,
  onToggleUnits,
  theme,
  onToggleTheme,
  onGeolocate,
  geoLoading,
  onCompare,
  rainAlerts,
  onToggleRainAlerts,
  dailySummaryEnabled,
  onDailySummary,
}) => (
  <div className="windy-controls" data-testid="control-stack">
    <div className="windy-ctl-group">
      <Btn testid="map-zoom-in" title="Perbesar" onClick={() => mapRef.current?.zoomIn()}>
        <Plus className="w-4 h-4" />
      </Btn>
      <Btn testid="map-zoom-out" title="Perkecil" onClick={() => mapRef.current?.zoomOut()}>
        <Minus className="w-4 h-4" />
      </Btn>
    </div>
    <div className="windy-ctl-group">
      <Btn testid="geolocation-button" title="Gunakan lokasi saya" onClick={onGeolocate}>
        {geoLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Navigation className="w-4 h-4 text-primary" />}
      </Btn>
      <Btn testid="unit-toggle-button" title="Ganti satuan" onClick={onToggleUnits}>
        <span className="num text-xs font-bold">{units === "metric" ? "°C" : "°F"}</span>
      </Btn>
      <Btn testid="theme-toggle-button" title="Ganti tema" onClick={onToggleTheme}>
        {theme === "dark" ? <Sun className="w-4 h-4 text-amber-400" /> : <Moon className="w-4 h-4 text-indigo-500" />}
      </Btn>
    </div>
    <div className="windy-ctl-group">
      <Btn testid="compare-button" title="Bandingkan kota" onClick={onCompare}>
        <LayoutGrid className="w-4 h-4 text-primary" />
      </Btn>
      <Btn testid="rain-alert-toggle" title="Notifikasi hujan" onClick={onToggleRainAlerts} active={rainAlerts}>
        {rainAlerts ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4 text-muted-foreground" />}
      </Btn>
      <Btn
        testid="daily-summary-button"
        title="Ringkasan pagi"
        onClick={onDailySummary}
        active={dailySummaryEnabled}
        activeClass="bg-amber-400 text-slate-900"
      >
        <Sunrise className={`w-4 h-4 ${dailySummaryEnabled ? "" : "text-amber-400"}`} />
      </Btn>
    </div>
  </div>
);
